import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Field, reduxForm } from 'redux-form';
import { renderToggle } from 'src/components/misc/redux-form-helpers';
import { scrollToAnchor } from 'src/utils/helpers';
import MultiLanguageInput from 'src/components/misc/multi-language-input';

class CustomerGroupSettingsEditForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {};
    }

    render() {
        const { t, handleSubmit } = this.props;

        return (
            <form className="form-horizontal" role="form" onSubmit={handleSubmit}>
                <div>
                    <div className="row">
                        <div className="col-md-6">
                            <Field
                                name="invoicePaymentEnabled"
                                label={t('customer_group.invoice_payment_allowed')}
                                labelPosition="right"
                                component={renderToggle}
                            />
                        </div>
                        <div className="col-md-12">
                            {t('customer_group_settings.not_transported_persons')}
                            <Field
                                name="groupOfPersonsNotTransported"
                                placeholder={t('customer_group_settings.not_transported_persons')}
                                label={t('customer_group_settings.not_transported_persons')}
                                t={t}
                                component={MultiLanguageInput}
                                componentType="renderRichTextEditorMultiLang"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};
    return errors;
};

const onSubmitFail = (errors, dispatch) => {
    let field;
    if (field) scrollToAnchor(field);
};

export default reduxForm({
    form: 'busEdit',
    onSubmitFail,
    validate,
    asyncBlurFields: ['name', 'vin'],
})(CustomerGroupSettingsEditForm);
